export default __webpack_public_path__ + "static/media/ImageAutomationFailed.1b48abf0.gif";